export const SIA = (props) => (
  <a
    aria-label="Sosyal İnovasyon Ajansı Website linki"
    href="https://www.sosyalinovasyonajansi.com/"
    target="_blank"
    rel="noreferrer"
    className="flex items-center justify-center"
  >
    <svg viewBox="0 0 30.17 14.9">
      <g id="Layer_1-2" data-name="Layer 1" {...props}>
        <g>
          <path
            className="cls-1"
            d="M12.84,0c.28.18.54.37.78.59.73.67.57,1.87-.31,2.32-.52.27-1.14.19-1.58-.18-.75-.64-1.95-1.13-3.27-1.13-2.29,0-3.38.96-3.38,2.17,0,1.43,1.68,1.82,3.64,2.05,2.9.36,5.63,1.06,6.38,3.66l1.58-3.61c1.21-2.77-.82-5.88-3.84-5.88"
          />
          <path
            className="cls-1"
            d="M2.61,11.55l.08-.04c.61-.31,1.33-.14,1.78.38.92,1.1,2.43,1.59,4.01,1.59,1.93,0,3.76-.68,3.76-2.45,0-1.54-1.61-2.17-3.78-2.4-.02,0-.04,0-.06,0-3.24-.39-6.37,1.36-7.68,4.36l-.71,1.62h2.97c-.32-.27-.61-.59-.87-.94-.52-.71-.26-1.71.52-2.11"
          />
          <path
            className="cls-2"
            d="M18.84,8.35s.08-.08.08-.15-.03-.11-.08-.15c-.05-.04-.14-.07-.27-.1-.2-.04-.35-.11-.45-.18-.1-.08-.15-.18-.15-.31s.06-.25.18-.34c.12-.1.27-.14.47-.14s.35.05.47.15c.12.1.18.22.17.37h0s-.35,0-.35,0c0-.07-.03-.13-.08-.18-.06-.05-.13-.07-.21-.07s-.15.02-.2.05c-.05.04-.07.09-.07.15,0,.06.02.1.07.14.05.03.13.06.27.09.21.04.36.11.46.18.1.08.15.18.15.31,0,.15-.06.27-.18.36-.12.09-.29.14-.49.14s-.37-.05-.5-.16c-.13-.11-.19-.23-.18-.38h0s.34,0,.34,0c0,.09.04.16.1.2.06.04.14.07.24.07.1,0,.17-.03.22-.06"
          />
          <path
            className="cls-2"
            d="M19.74,7.81v.05c0,.2.05.36.15.48.1.13.23.19.4.19s.3-.06.4-.19c.1-.13.15-.29.15-.48v-.05c0-.2-.05-.36-.15-.48-.1-.13-.23-.19-.4-.19s-.3.06-.4.19c-.1.13-.15.29-.15.48M19.56,7.86v-.05c0-.24.06-.44.2-.59.13-.15.31-.23.52-.23s.39.08.52.23c.13.15.2.35.2.59v.05c0,.24-.06.44-.2.59-.13.15-.31.23-.52.23s-.39-.08-.52-.23c-.13-.15-.2-.35-.2-.59"
          />
          <path
            className="cls-2"
            d="M21.95,8.53h0c.13,0,.23-.03.31-.08.08-.06.11-.13.11-.21s-.04-.15-.1-.2c-.06-.06-.18-.1-.34-.14-.2-.04-.35-.1-.44-.17-.09-.07-.13-.17-.13-.29s.06-.23.16-.31c.1-.08.25-.13.43-.13s.32.04.43.13c.11.09.16.2.15.35h0s-.17,0-.17,0c0-.09-.04-.18-.12-.24-.08-.06-.18-.1-.31-.1s-.22.03-.29.08c-.07.06-.11.13-.11.2,0,.08.03.15.09.2.06.05.18.09.36.13.18.04.32.1.41.18.09.08.14.18.14.31s-.06.24-.17.32c-.11.08-.26.13-.45.13s-.34-.05-.45-.14c-.11-.09-.17-.21-.17-.34h0s.17,0,.17,0c0,.11.06.2.14.25.1.04.2.07.34.07"
          />
          <path
            className="cls-2"
            d="M23.02,9.38c-.06,0-.11,0-.14-.02l.02-.15s.07.01.12.01c.08,0,.13-.03.18-.08.05-.05.09-.13.13-.22l.09-.22-.64-1.61h.2l.45,1.2.06.2h0l.5-1.39h.2l-.71,1.9c-.05.13-.11.23-.18.29-.06.06-.17.11-.29.11"
          />
          <path
            className="cls-2"
            d="M24.58,8.22c0,.09.03.16.09.22.06.06.15.08.27.08.12,0,.22-.03.33-.09.1-.06.18-.14.22-.24v-.34h-.36c-.16,0-.29.03-.39.1-.1.07-.15.16-.15.27M24.9,8.68c-.16,0-.28-.04-.37-.13-.09-.08-.13-.2-.13-.35s.06-.27.2-.36c.13-.09.31-.13.53-.13h.36v-.2c0-.12-.03-.21-.11-.27-.08-.06-.17-.1-.31-.1s-.24.03-.32.09c-.08.06-.13.14-.13.23h-.17c0-.13.05-.24.17-.33.12-.09.27-.14.45-.14s.33.05.43.14c.11.09.16.22.16.39v.8c0,.11.01.22.04.33h-.19c-.02-.1-.04-.19-.04-.27-.06.09-.15.16-.24.22-.11.05-.22.08-.34.08"
          />
          <rect
            className="cls-2"
            x="26.18"
            y="6.28"
            width=".18"
            height="2.36"
          />
          <path
            className="cls-2"
            d="M17.03,11.41h-.36v-1.64h.36v1.64ZM17.03,9.36h-.36v-.32h.36v.32Z"
          />
          <path
            className="cls-2"
            d="M17.49,9.76h.16v.29c.13-.21.3-.31.55-.31.18,0,.31.06.41.16.09.11.14.28.14.51v1h-.18v-1c0-.18-.04-.31-.11-.39-.07-.08-.17-.12-.29-.12s-.24.03-.31.1c-.08.06-.14.15-.18.27v1.15h-.18v-1.65Z"
          />
          <path
            className="cls-2"
            d="M19.3,10.56v.05c0,.2.05.36.15.48.1.13.23.19.4.19s.3-.06.4-.19c.1-.13.15-.29.15-.48v-.05c0-.2-.05-.36-.15-.48-.1-.13-.23-.19-.4-.19s-.3.06-.4.19c-.1.13-.15.29-.15.48M19.12,10.61v-.05c0-.24.06-.44.2-.59.13-.15.31-.23.52-.23s.39.08.52.23c.13.15.2.35.2.59v.05c0,.24-.06.44-.2.59-.13.15-.31.23-.52.23s-.39-.08-.52-.23c-.14-.15-.2-.35-.2-.59"
          />
          <polygon
            className="cls-2"
            points="20.94 9.76 21.39 10.99 21.45 11.18 21.46 11.18 21.51 10.99 21.96 9.76 22.15 9.76 21.53 11.41 21.38 11.41 20.76 9.76 20.94 9.76"
          />
          <path
            className="cls-2"
            d="M22.52,10.97c0,.09.03.16.09.22.06.06.15.08.27.08.12,0,.22-.03.33-.09.1-.06.18-.14.22-.24v-.34h-.36c-.16,0-.29.03-.39.11-.1.08-.15.16-.15.27M22.84,11.44c-.16,0-.28-.04-.37-.13-.09-.08-.13-.2-.13-.35s.06-.27.2-.36c.13-.09.31-.13.53-.13h.36v-.21c0-.12-.03-.21-.11-.27-.08-.06-.18-.1-.31-.1s-.24.04-.32.09c-.08.06-.13.14-.13.23h-.17c0-.13.05-.24.17-.34.12-.09.27-.14.45-.14s.33.05.43.14c.11.09.16.22.16.39v.8c0,.11.01.22.04.33h-.19c-.02-.1-.04-.19-.04-.27-.06.09-.15.16-.24.22-.11.06-.22.08-.34.08"
          />
          <path
            className="cls-2"
            d="M24.64,11.29h0c.13,0,.23-.03.31-.08.08-.06.11-.13.11-.21s-.03-.15-.1-.2c-.06-.05-.18-.1-.34-.14-.2-.04-.35-.1-.44-.17-.09-.07-.13-.17-.13-.29s.06-.23.16-.31c.1-.08.25-.13.43-.13s.32.04.43.13c.11.09.16.2.15.35h0s-.17,0-.17,0c0-.09-.04-.18-.12-.24-.08-.06-.18-.1-.31-.1s-.22.03-.29.08c-.07.06-.11.13-.11.2s.03.15.09.2c.06.05.18.09.36.13.18.04.32.1.41.18.09.08.14.18.14.31s-.06.24-.17.32c-.11.08-.26.13-.45.13s-.34-.05-.45-.14c-.11-.09-.17-.21-.17-.34h0s.17,0,.17,0c0,.11.06.2.14.25.08.06.2.07.34.07"
          />
          <path
            className="cls-2"
            d="M25.72,12.14c-.06,0-.11,0-.14-.02l.02-.15s.07.01.12.01c.08,0,.13-.03.18-.08.05-.05.09-.13.13-.22l.09-.22-.64-1.61h.2l.45,1.2.06.2h0l.5-1.39h.2l-.71,1.89c-.05.13-.11.23-.18.29-.06.06-.17.11-.29.11"
          />
          <path
            className="cls-2"
            d="M27.27,10.56v.05c0,.2.05.36.15.48.1.13.23.19.4.19s.3-.06.4-.19c.1-.13.15-.29.15-.48v-.05c0-.2-.05-.36-.15-.48-.1-.13-.23-.19-.4-.19s-.3.06-.4.19c-.1.13-.15.29-.15.48M27.08,10.61v-.05c0-.24.06-.44.2-.59.13-.15.31-.23.52-.23s.39.08.52.23c.13.15.2.35.2.59v.05c0,.24-.06.44-.2.59-.13.15-.31.23-.52.23s-.39-.08-.52-.23c-.14-.15-.2-.35-.2-.59"
          />
          <path
            className="cls-2"
            d="M28.92,9.76h.16v.29c.13-.21.3-.31.55-.31.18,0,.31.06.41.16.09.11.14.28.14.51v1h-.18v-1c0-.18-.03-.31-.11-.39-.07-.08-.17-.12-.29-.12s-.24.03-.31.1c-.08.06-.14.15-.18.27v1.15h-.18v-1.65Z"
          />
          <path
            className="cls-2"
            d="M17.45,13.7h0c0,.06.02.11.06.15.04.03.11.06.19.06s.16-.02.24-.07c.08-.04.13-.1.15-.16v-.24h-.29c-.11,0-.19.03-.25.08-.06.05-.09.12-.09.2M17.61,14.2c-.17,0-.3-.04-.39-.13-.09-.09-.14-.21-.14-.36,0-.16.06-.28.19-.37.13-.09.3-.13.53-.13h.29v-.15c0-.08-.03-.15-.08-.2-.05-.05-.12-.07-.21-.07s-.16.02-.21.06c-.05.04-.08.09-.08.16h-.36c0-.14.05-.26.18-.36s.29-.15.48-.15.35.05.46.15c.11.1.18.24.18.42v.73c0,.13.02.26.06.38h-.37c-.03-.08-.04-.17-.05-.24-.06.08-.12.15-.2.2-.08.05-.18.07-.27.07"
          />
          <path
            className="cls-2"
            d="M19.08,12.12h-.18v-.24h.18v.24ZM18.91,12.59h.18v1.78c0,.17-.04.3-.12.39-.08.09-.2.14-.34.14-.05,0-.1,0-.17-.03l.02-.15s.09.02.14.02c.09,0,.16-.03.21-.09.05-.06.08-.15.08-.27v-1.78h0Z"
          />
          <path
            className="cls-2"
            d="M19.71,13.73c0,.09.03.16.09.22.06.06.15.08.27.08.12,0,.22-.03.33-.09.1-.06.18-.14.22-.24v-.34h-.36c-.16,0-.29.03-.39.1-.1.07-.15.16-.15.27M20.03,14.2c-.16,0-.28-.04-.37-.13-.09-.08-.13-.2-.13-.35s.06-.27.2-.36c.13-.09.31-.13.53-.13h.36v-.2c0-.12-.03-.21-.11-.27-.08-.06-.17-.1-.31-.1s-.24.03-.32.09c-.08.06-.13.14-.13.23h-.17c0-.13.05-.24.17-.33.12-.09.27-.14.45-.14s.33.05.43.14c.11.09.16.22.16.39v.8c0,.11.01.22.04.33h-.19c-.02-.1-.04-.19-.04-.27-.06.09-.15.16-.24.22-.11.05-.22.08-.34.08"
          />
          <path
            className="cls-2"
            d="M21.28,12.52h.16v.29c.13-.21.3-.31.55-.31.18,0,.31.06.41.16.09.11.14.28.14.51v1h-.18v-1c0-.18-.04-.31-.11-.39-.07-.08-.17-.12-.29-.12s-.24.04-.31.1c-.08.06-.14.15-.18.27v1.15h-.18v-1.65Z"
          />
          <path
            className="cls-2"
            d="M23.56,14.04h0c.13,0,.23-.03.31-.08.08-.06.11-.13.11-.21s-.03-.15-.1-.21c-.06-.06-.18-.1-.34-.14-.2-.04-.35-.1-.44-.17-.09-.07-.13-.17-.13-.29s.06-.23.16-.31c.1-.08.25-.13.43-.13s.32.04.43.13c.1.09.16.2.15.35h0s-.17,0-.17,0c0-.09-.04-.18-.12-.24-.08-.06-.18-.1-.31-.1s-.22.03-.29.08c-.07.06-.11.13-.11.2,0,.08.03.15.09.2.06.05.18.09.36.13.18.04.32.1.41.18.09.08.14.18.14.31s-.06.24-.17.32c-.11.08-.26.13-.45.13s-.34-.05-.45-.14c-.11-.09-.17-.21-.17-.34h0s.17,0,.17,0c0,.11.06.2.14.25.1.05.21.08.34.08"
          />
          <rect
            className="cls-2"
            x="24.6"
            y="12.52"
            width=".18"
            height="1.64"
          />
        </g>
      </g>
    </svg>
  </a>
);
